import{useLayoutEffect as o,useEffect as m}from"react";import{isWindowDefined as r}from"../utils/common.js";const t=r()?o:m;export{t as useIsomorphicLayoutEffect};
